<app-toast></app-toast>
<p-confirmDialog />
<app-loading-indicator></app-loading-indicator>
<router-outlet></router-outlet>
<app-user-profile-dialog></app-user-profile-dialog>
